import Heading from './Heading'

export default Heading
// eslint-disable-next-line import/export
export * from './Heading'
